import React from 'react'
import Header from '../../Components/Header/Header'
import WinnersLottery from '../../Components/WinnersLottery/WinnersLottery'
import Footer from '../../Components/Footer/Footer'

const Result = () => {
  return (
    <div>
        <Header />
        <Footer />
      
    </div>
  )
}

export default Result
